import styled from 'styled-components'

export const StepperContainer = styled.div`
  width: 50%;
  margin: 24px auto 0;
`
